// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc */
import * as React from 'react';

type JsonLdListItemData = {|
  name: string,
  url: string,
|};

type ListItemJsonLdProps = {|
  listItemData: JsonLdListItemData[],
  name: string,
  description?: string,
|};

/**
 * Generates the list items into a json+ld schema for google to display our results in the google srp
 * Currently unused, can be used when https://jira.tamg.io/browse/WP-429 is complete to add header/meta description
 */
/* eslint-disable react/no-danger */
const ListItemJsonLd = (listItemData: ListItemJsonLdProps) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'ItemList',
        name: listItemData.name,
        description: listItemData.description || undefined,
        ItemListOrder: 'http://schema.org/ItemListOrderAscending',
        itemListElement: listItemData.listItemData.map((item, index) => ({
          '@type': 'ListItem',
          position: (index + 1).toString(),
          name: item.name,
          url: item.url,
        })),
      }),
    }}
  />
);

/* eslint-enable react/no-danger */
export default ListItemJsonLd;
